var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1F7AE0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3731 16.7501L16.5423 21.9193C16.691 22.068 16.7644 22.2421 16.7625 22.4414C16.7606 22.6408 16.682 22.818 16.5269 22.9732C16.3718 23.118 16.1962 23.193 16 23.1982C15.8039 23.2033 15.6282 23.1283 15.4731 22.9732L9.13273 16.6328C9.03914 16.5392 8.97312 16.4405 8.93465 16.3366C8.89619 16.2328 8.87695 16.1206 8.87695 16.0001C8.87695 15.8796 8.89619 15.7674 8.93465 15.6636C8.97312 15.5597 9.03914 15.461 9.13273 15.3674L15.4731 9.02706C15.6116 8.88859 15.783 8.81776 15.9875 8.81456C16.192 8.81136 16.3718 8.88219 16.5269 9.02706C16.682 9.18217 16.7596 9.36037 16.7596 9.56166C16.7596 9.76294 16.682 9.94114 16.5269 10.0963L11.3731 15.2501H22.75C22.9628 15.2501 23.141 15.3219 23.2846 15.4655C23.4282 15.6091 23.5 15.7873 23.5 16.0001C23.5 16.2129 23.4282 16.3911 23.2846 16.5347C23.141 16.6783 22.9628 16.7501 22.75 16.7501H11.3731Z",
    fill: "#1F7AE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6b46c63fd2daaf96f97d2312b6375717.svg";
export { ForwardRef as ReactComponent };